import * as React from 'react';

/**
 * Visual language for a chat surface. `agent` is the new runtime's quieter,
 * transcript-first presentation.
 */
export type ChatSurfaceVariant = 'default' | 'agent';

const ChatSurfaceVariantContext =
  React.createContext<ChatSurfaceVariant>('default');

export const ChatSurfaceVariantProvider = ChatSurfaceVariantContext.Provider;

export const useChatSurfaceVariant = (): ChatSurfaceVariant =>
  React.useContext(ChatSurfaceVariantContext);
